import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { OverflowNode } from "@lexical/overflow";
import { HorizontalRuleNode } from "@lexical/react/LexicalHorizontalRuleNode";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table";

import { ParagraphNode, TextNode } from "lexical";

import { TweetNode } from "@/components/editor/nodes/embeds/tweet-node";
import { YouTubeNode } from "@/components/editor/nodes/embeds/youtube-node";
import { ImageNode } from "@/components/editor/nodes/image-node";

export const nodes = [
  // Basic text nodes
  HeadingNode,
  ParagraphNode,
  TextNode,
  QuoteNode,
  // Lists
  ListNode,
  ListItemNode,
  // Overflow
  OverflowNode,
  // Links
  AutoLinkNode,
  LinkNode,
  // Tables
  TableNode,
  TableRowNode,
  TableCellNode,
  // Media
  ImageNode,
  // Embeds
  YouTubeNode,
  TweetNode,
  // Other
  HorizontalRuleNode,
  CodeNode,
  CodeHighlightNode,
];
